import {
  UPDATE_ADDRESS,
  UPDATE_ADDRESS_ATTRIBUTE,
  UPDATE_PENDING_ORDER,
} from './types';
import { getEmptyPendingOrderPayload } from '../../constants';

export const updateAddress = (address, dispatch) => {
  if (dispatch) {
    dispatch({ type: UPDATE_ADDRESS, payload: { address } });
  } else {
    return { type: UPDATE_ADDRESS, payload: { address } };
  }
};

export const updateAddressAttribute = (attribute: any, value: any) => {
  return { type: UPDATE_ADDRESS_ATTRIBUTE, payload: { attribute, value } };
};

export const resetPendingOrder = () => {
  return {
    type: UPDATE_PENDING_ORDER,
    payload: getEmptyPendingOrderPayload(),
  };
};
